import { AES } from 'crypto-js';
import { SECRET } from '../constants/Secret';

export function safeData(data: string) {
  const cipherText = AES.encrypt(JSON.stringify(data), SECRET);
  return cipherText.toString();
}
